export default "__VITE_ASSET__DYNPu0_o__"